/* Product Card Functions */

function adjustDescriptionPosition(figure) {
    const description = figure.querySelector('.description');
    if (!description) return;
    const figureHeight = figure.clientHeight;
    const descriptionHeight = description.clientHeight;
    const descriptionOverlay = description.querySelector('.overlay');
    if (!descriptionOverlay || descriptionOverlay.textContent.trim() === "" || descriptionOverlay.innerHTML.trim() === "") return;
    if (descriptionHeight > figureHeight) {
        description.style.bottom = `${figureHeight - descriptionHeight}px`;
    } else {
        description.style.bottom = '0';
    }
}

function resetDescriptionPosition(figure) {
    const description = figure.querySelector('.description');
    if (!description) return;
    description.style.bottom = '';
}

function initProductDescriptions() {
    document.querySelectorAll('.product-card figure').forEach(figure => {
        figure.setAttribute('tabindex', '0');
        figure.addEventListener('mouseenter', () => adjustDescriptionPosition(figure));
        figure.addEventListener('mouseleave', () => resetDescriptionPosition(figure));
        figure.addEventListener('focusin', () => adjustDescriptionPosition(figure));
        figure.addEventListener('focusout', () => resetDescriptionPosition(figure));
        window.addEventListener('resize', () => resetDescriptionPosition(figure));
    });
    document.querySelectorAll('.product-card .details').forEach(el => {
        el.addEventListener('click', e => e.stopPropagation());
    });
}

document.addEventListener("DOMContentLoaded", () => initProductDescriptions());

document.addEventListener('facetChange', function() {
    const productGrid = document.querySelector('.product-grid-container');
    if (!productGrid) return;
    const observer = new MutationObserver(function(mutationsList, observer) {
        initProductDescriptions();
        observer.disconnect();
    });
    observer.observe(productGrid, { childList: true, subtree: true });
});


/* Product Variant Functions */

function setProductCurrentVariant(el, locale) {
    let localePrefix = (locale === 'en') ? '/' + locale : '';
    const fetchUrl = localePrefix + '/products/' + el.dataset.productHandle + '.js';

    fetch(fetchUrl)
    .then(response => {
        if (!response.ok) throw new Error('Product not found.');
        return response.json();
    })
    .then(productData => {
        if (productData.variants && productData.variants.length > 0) {
            findSelectedVariant(el, el.dataset.productHandle, productData.variants);
        }
    })
    .catch(error => console.error('Error:', error));
}

function findSelectedVariant(el, handle, variants) {
    // Contexte : modale ou page collection
    const modal = el.closest('quick-add-modal');
    const productElement = modal
        ? modal
        : document.querySelector("section[data-product-handle='" + handle + "']");

    if (!productElement) {
        console.error('Conteneur produit introuvable pour:', handle);
        return;
    }

    const currentColor = productElement.querySelector("input[name='color-" + handle + "']:checked");
    const colorOption = currentColor ? currentColor.dataset.option : null;
    const currentSelection = productElement.querySelector("select[name='select-" + handle + "']");
    const selectOption = currentSelection ? currentSelection.dataset.option : null;

    if (!colorOption && !selectOption) {
        console.error("Aucune option couleur ou sélection trouvée.");
        return;
    }

    const matchedVariant = variants.find(variant => {
        if (colorOption && selectOption) return variant[colorOption] === currentColor.value && variant[selectOption] === currentSelection.value;
        if (colorOption) return variant[colorOption] === currentColor.value;
        return variant[selectOption] === currentSelection.value;
    });

    if (!matchedVariant) {
        console.error('Aucune variante correspondante trouvée.');
        return;
    }

    // Mettre à jour l'ID de variante
    const variantInput = productElement.querySelector("input[name='id']");
    if (variantInput) variantInput.value = matchedVariant.id;

    // Mettre à jour l'image
    if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
        productElement.querySelectorAll(".featured-media > img").forEach(img => {
            img.src = matchedVariant.featured_image.src;
            img.srcset = matchedVariant.featured_image.src;
        });
    }

    // Mettre à jour le bouton add to cart
    const btn = productElement.querySelector("form button[type='submit']");
    if (btn && typeof cartTranslations !== 'undefined') {
        btn.disabled = !matchedVariant.available;
        const span = btn.querySelector('span');
        if (span) span.innerHTML = matchedVariant.available ? cartTranslations['add_to_cart'] : cartTranslations['sold_out'];
    }
}
